export class FilterArchive {
	/*
	 * Init the handler
	 *
	 * @param    {HTMLElment} rootEl       The root element of the filter
	 * @param    {string}     rootClass    The root class of the filter
	 */
	constructor(rootEl, rootClass) {
		this.rootEl = rootEl;
		this.rootClass = rootClass;

		this.busyClass = 'loading';

		this.filterCheckboxesClass = 'filter-checkboxes';

		this.headerClass = `${this.rootClass}__form`;
		this.headerEl = this.rootEl.querySelector(`.${this.headerClass}`);

		this.ajaxTargetClass = `${this.rootClass}__ajax-target`;
		this.ajaxTargetEl = this.rootEl.querySelector(
			`.${this.ajaxTargetClass}`
		);

		if (this.headerEl) {
			this.headerEl.addEventListener(
				'change',
				this.handleChange.bind(this)
			);
			this.headerEl.addEventListener(
				'submit',
				this.handleSubmit.bind(this)
			);
		}
	}

	/*
	 * Fetch markup from an updated page
	 *
	 * @return    {void}
	 */
	fetchGridItems() {
		// Construct the request URL
		const data = new URLSearchParams();
		for (const pair of new window.FormData(this.headerEl)) {
			data.append(pair[0], pair[1]);
		}
		const url = `?${data.toString()}`;

		// Abort in-progress fetch
		if (this.abortController instanceof AbortController) {
			this.abortController.abort();
		}

		// Create an abort signal
		const controller = new AbortController();
		this.abortController = controller;

		// Flag the handler as busy
		this.rootEl.classList.add(this.busyClass);

		// Fetch
		this.currentFetch = window
			.fetch(url, { signal: controller.signal })
			.then((response) => response.text())
			.then(this.updateFromFetch.bind(this))
			.finally(() => {
				this.rootEl.classList.remove(this.busyClass);
				delete this.abortController;
			});
	}

	/*
	 * Update page elements using page source returned by a fetch request
	 *
	 * @param     {string} remoteSource    HTML returned by a fetch request
	 * @return    {void}
	 */
	updateFromFetch(remoteSource) {
		// Block ID
		const blockId = this.rootEl.getAttribute('id');

		// Parse the remote markup
		const parser = new window.DOMParser();
		const remoteDocument = parser.parseFromString(
			remoteSource,
			'text/html'
		);

		// Replace content
		const remoteajaxTargetEl = remoteDocument.querySelector(
			`#${blockId} .${this.ajaxTargetClass}`
		);
		if (remoteajaxTargetEl instanceof window.HTMLElement) {
			this.ajaxTargetEl.innerHTML = remoteajaxTargetEl.innerHTML;
		}
	}

	/*
	 * Update the URL using currently selected filters
	 *
	 * @return    {void}
	 */
	updateUrl() {
		// Get a list of all filter checkbox elements
		const filterCheckboxEls = Array.from(
			this.headerEl.querySelectorAll(`.${this.filterCheckboxesClass}`)
		);

		// Set new URL so paged is set to 1
		let newPath = '/' + this.rootEl.dataset.path + '/';
		
		if(this.rootEl.dataset.site) {
			let site = this.rootEl.dataset.site.replace(window.location.origin, '')
			newPath = site + '/' + this.rootEl.dataset.path + '/';
		} 
		// Parse the current URL
		const parsedUrl = new URL(
			newPath,
			window.location.origin
		);

		// Remove all existing filters from the parsed URL
		filterCheckboxEls.forEach((filterCheckboxEl) => {
			const taxonomySlug = filterCheckboxEl.dataset.taxonomy;
			parsedUrl.searchParams.delete(taxonomySlug);
		}, this);

		// Add each checked filter to the parsed URL
		filterCheckboxEls.forEach((filterCheckboxEl) => {
			const taxonomySlug = filterCheckboxEl.dataset.taxonomy;
			const checkboxEls = Array.from(
				filterCheckboxEl.querySelectorAll(
					'input[type="checkbox"]:checked'
				)
			);

			checkboxEls.forEach((checkboxEl, i) => {
				const termId = parseInt(checkboxEl.getAttribute('value'), 10);
				parsedUrl.searchParams.set(`${taxonomySlug}[${i}]`, termId);
			}, this);
		}, this);

		// Replace the current URL
		window.history.replaceState(
			null,
			document.title,
			decodeURI(parsedUrl.toString())
		);
	}

	/*
	 * Handle a form elements changing
	 *
	 * @return    {void}
	 */
	handleChange() {
		this.updateUrl();
		this.fetchGridItems();
	}

	/*
	 * Handle a form submissions
	 *
	 * @param     {Event} event    An event raised by the user action
	 * @return    {void}
	 */
	handleSubmit(event) {
		event.preventDefault();
		this.updateUrl();
		this.fetchGridItems();
	}
}
